import { IQuerySource } from "../core/reporting-models";


export interface ISqlQueryBuild {
    id: string;
    sqlCode: string;
    tableSetId: string;
    querySourceId: string;
    querySource: IQuerySource;
}

export enum QuerySourceNodeType {
    QueryOption = "query-option",
    QueryOptionGroup = "query-option-group",
}
